import React, { Component } from 'react';
import { Jumbotron, Container, Row, Col, Form, Button, Table } from 'react-bootstrap';
import Menu from '../../menu';
import funciones from '../../../middleware/funciones';
import SearchClient from '../../subcomponent/searchClient';
import config from '../../../config';
import { CSVLink } from "react-csv";

export class reporteRecibos extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        //const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        this.state = {
            empresa: currentCompany,
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            clientes: [],
            infoReporte: [],
            cliente: ""
        };
    }
    componentDidMount = () => {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/clients/', datasend).then(response => response.json())
            .then(data => this.setState({ clientes: data }));
    }

    selectClient = (client) => {
        const { DOCUMENTO_CLIENTE } = client;
        this.setState({ cliente: DOCUMENTO_CLIENTE })
    }

    updateReport = () => {
        const busqueda = {
            cliente: this.state.cliente,
            fecha_ini: this.state.fecha_inicial,
            fecha_fin: this.state.fecha_final
        }
        const datasend = {
            method: 'POST',
            body: JSON.stringify(busqueda),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa
            }
        };

        fetch(config.servBackEnd + '/reports/paymentreport', datasend).then(response => response.json())
            .then(datos => {
                const { data } = datos;
                if (datos.ok) {
                    this.setState({ infoReporte: data })
                } else {
                    this.setState({ infoReporte: [] })
                }
            });
    }

    impresionPDF = ({target}, id) => {
        target.disabled = true;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/payment/getpdf/' + id, datasend)
            .then((res) => {
                if (res.ok) return res.blob();
            }).then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function () {
                    window.setTimeout(function () {
                        document.querySelector('#pdf-frame').contentWindow.print();
                        target.disabled=false;
                    }, 1000)
                })
            .catch((err) => {
                //console.error(err);
                target.disabled=false;
            });       
    }

    mailerDoc=({target}, id)=>{
        target.disabled = true;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/files/createsendpayment/' + id, datasend)
        .then(data => {
            target.disabled = false;
            //console.log(data);
        });
    }
    render() {
        const { infoReporte } = this.state;
        const impresionPDF = this.impresionPDF;
        const mailerDoc = this.mailerDoc;
        return (
            <div className="contenedor">
                <iframe id="pdf-frame"></iframe>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h1>Reporte de recibos</h1>
                </Jumbotron>
                <Container fluid>
                    <Row className="justify-content-md-center" >
                        <Col className="mb-2" xs={5} lg={1}>CLIENTE</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <SearchClient data={this.state.clientes} event={this.selectClient}></SearchClient>
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} />
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center" >
                        <Col className="mb-2" xs={12} lg={2}>
                            <CSVLink data={infoReporte} filename={"REPORTE_RECIBOS.csv"} separator={";"}>
                                <Button disabled={infoReporte.length === 0} variant="success">Descargar Reporte</Button>
                            </CSVLink>
                        </Col>
                        <Col className="mb-2" xs={12} lg={2}>
                            <Button id="actualizar" name="actualizar" onClick={this.updateReport}>Generar Reporte</Button>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Table>
                        <thead>
                            <tr>
                                <th>DOCUMENTO CLIENTE</th>
                                <th>NOMBRE CLIENTE</th>
                                <th>FECHA DOCUMENTO</th>
                                <th>DOCUMENTO</th>
                                <th>METODO DE PAGO</th>
                                <th>TOTAL VALOR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {infoReporte.map((element, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{element.CLIENTE_CODIGO}</td>
                                        <td>{element.NOMBRE_CLIENTE}</td>
                                        <td>{funciones.formatDate(element.FECHA_DOCUMENTO)}</td>
                                        <td>{element.TIPO_DOCUMENTO_RECIBO+"-"+element.NUMERO_DOCUMENTO_RECIBO}</td>
                                        <td>{element.METODO_PAGO}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.TOTAL_VALOR)}</td>
                                        <td ><Button className="buttonP" onClick={(e) => impresionPDF(e, element.ID)} variant="outline-primary"></Button></td>
                                        <td ><Button className="buttonE" onClick={(e) => mailerDoc(e, element.ID)} variant="outline-primary"></Button></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </Container>
            </div>
        )
    }
}

export default reporteRecibos
